/**
 * Utilitários de geolocalização — 100% client-side.
 *
 * A coordenada do usuário NUNCA sai do aparelho: a ordenação por distância da
 * Home é feita localmente (relevante pras declarações de Data Safety / App
 * Privacy — "não coletado"). Se um dia virar busca server-side, atualizar as
 * fichas das lojas ANTES do deploy.
 */

const EARTH_RADIUS_KM = 6371;

/** Distância great-circle (Haversine) em km entre dois pares lat/lng. */
export function haversineKm(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(a));
}

/** "850 m" abaixo de 1 km; "1,2 km" / "12 km" acima (pt-BR). */
export function formatDistance(km: number): string {
  if (!Number.isFinite(km) || km < 0) return '';
  if (km < 1) return `${Math.round(km * 1000)} m`;
  if (km < 10) return `${km.toFixed(1).replace('.', ',')} km`;
  return `${Math.round(km)} km`;
}
